import { gql, useLazyQuery, useQuery } from "@apollo/client"
import { ACTION_FIELDS } from "../actions"

const JOB_STEP_ACTIONS_QUERY = gql`
  ${ACTION_FIELDS}
  query JobStep($job: ID!, $step: ID!) {
    job: jobV2(id: $job) {
      step(id: $step) {
        actions {
          ...ActionFields
        }
      }
    }
  }
`

const useQueryJobStepActions = (options) => useQuery(JOB_STEP_ACTIONS_QUERY, options)

const useLazyQueryJobStepActions = (options) => useLazyQuery(JOB_STEP_ACTIONS_QUERY, options)

export { useQueryJobStepActions, useLazyQueryJobStepActions }
